import {useTranslation} from "react-i18next";
import React from "react";
import Select from "./Select";

export default function OsSelect(props) {

  return (
    <Select {...props} >
      <Option value="ios">iOS</Option>
      <Option value="android">Android</Option>
    </Select>
  )
}

